
const splideMV = '#splide-mv';
const splideMV_options = {
  type   : 'loop',
          autoplay: true,
          interval: 6000,
          perPage: 1,
          perMove: 1,
          rewind: false,
          updateOnMove: true,
          isNavigation: true,
          pagination: false,
          arrows: true,
          gap: 20,
          padding: '0',
          speed: 1500,
          focus  : 'center',
          breakpoints: {
            699: {
              perPage: 1,
            }
          },
}

var mySplide;
if (document.querySelectorAll(splideMV).length > 0) {
  // const mySplide = new Splide(splideMV, splideMV_options);
  mySplide = new Splide(splideMV, splideMV_options);
  mySplide.mount();
}

const thumbsSelector = '#splide-mv-thumbs';
if (document.querySelector(thumbsSelector)) {
  const thumbs = new Splide(thumbsSelector, {
    rewind      : true,
    isNavigation: true,
    pagination  : false,
    arrows      : false,
    // gap         : 10,
    // focus       : 'center',
    updateOnMove: true,
    fixedWidth  : 110,
    fixedHeight : 62,
    cover       : true,
    breakpoints : {
      1024: {
        fixedWidth: 100,
        fixedHeight: 56,
      },
      640 : {
        fixedWidth: 86,
        fixedHeight: 48,
      },
      390 : {
        fixedWidth: 74,
        fixedHeight: 42,
      },
    },
  });

  thumbs.mount();
  if (mySplide) mySplide.sync(thumbs);
}